import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { PaisDocumento, Error } from '@rpe/registro-personas-empresas-lib';

export const entityPaisesDocumentoAdapter: EntityAdapter<PaisDocumento> =
  createEntityAdapter<PaisDocumento>({
    selectId: (model) => model.id,
    sortComparer: (a: PaisDocumento, b: PaisDocumento): number =>
      a.id.toString().localeCompare(b.id.toString())
  });

export interface EntityPaisesDocumentoState extends EntityState<PaisDocumento> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityPaisesDocumentoState =
  entityPaisesDocumentoAdapter.getInitialState({
    isLoading: false,
    error: null
  });
